import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { PageBanner } from "../components/PageBanner";
import { ConsultationForm } from "../components/ConsultationForm";
import { Reveal, SectionHeading } from "../components/Reveal";
import { Contact } from "../components/home/Contact";
import { CheckCircle2 } from "lucide-react";

const EXPECTATIONS = [
  "A relaxed conversation about your needs, routines, and questions",
  "Guidance on the care options that best fit your situation",
  "A clear picture of the next steps — with no pressure and no obligation",
];

export default function ContactPage() {
  return (
    <div data-testid="contact-page">
      <Header />
      <main>
        <PageBanner
          testId="contact-banner"
          eyebrow="Get In Touch"
          title="Contact Us"
          description="We are here to answer your questions and help you find the right care. Reach out by phone or email, or visit us at our Surrey office."
        />
        <section data-testid="booking-section" className="py-24 lg:py-32 bg-white">
          <div className="max-w-7xl mx-auto px-5 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-20 items-start">
              <div>
                <SectionHeading title="Book a Free Care Consultation" />
                <Reveal delay={0.15}>
                  <div className="mt-6 space-y-5 text-lg leading-relaxed text-slate-600">
                    <p>
                      Choosing care starts with a simple conversation. Tell us a little about yourself or your loved one, pick a date and time that works for you, and our care team will reach out to arrange your complimentary consultation.
                    </p>
                    <p>
                      There is no cost and no obligation — just friendly, professional guidance to help you understand your options and decide what feels right for your family.
                    </p>
                  </div>
                </Reveal>
                <Reveal delay={0.25}>
                  <ul className="mt-8 space-y-4">
                    {EXPECTATIONS.map((item) => (
                      <li key={item} className="flex items-start gap-3">
                        <CheckCircle2 className="h-5 w-5 mt-0.5 shrink-0 text-brand-teal" strokeWidth={1.8} />
                        <span className="text-sm md:text-base text-slate-600">{item}</span>
                      </li>
                    ))}
                  </ul>
                </Reveal>
              </div>
              <Reveal delay={0.2}>
                <ConsultationForm />
              </Reveal>
            </div>
          </div>
        </section>
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
